// extracted by mini-css-extract-plugin
export default {"cardIcon":"CardLink_cardIcon__+xcSq","cardLinkContainer":"CardLink_cardLinkContainer__CVhQa"};